import React, { useState } from "react";
import adminApi from "../adminApi";
import { useLanguage } from "../context/LanguageContext";

export const MIN_PASSWORD_LENGTH = 8;

interface ChangePasswordDialogProps {
  onClose: () => void;
}

// Zmiana hasła zalogowanego użytkownika (wymaga obecnego hasła)
const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({ onClose }) => {
  const { t } = useLanguage();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (newPassword.length < MIN_PASSWORD_LENGTH) {
      setError(t("The new password must be at least 8 characters long."));
      return;
    }
    if (newPassword !== repeatPassword) {
      setError(t("The passwords do not match."));
      return;
    }

    setSaving(true);
    try {
      await adminApi.put("/account/password", { currentPassword, newPassword });
      setSaved(true);
    } catch (err: any) {
      const message = err?.response?.data?.error;
      setError(message === "Current password is incorrect" ? t("The current password is incorrect.") : t("Failed to change password."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dialog-overlay" role="dialog" aria-modal="true" aria-labelledby="change-password-title">
      <div className="dialog-card">
        <h3 id="change-password-title">{t("Change password")}</h3>

        {saved ? (
          <>
            <p className="dialog-success">{t("Password changed.")}</p>
            <div className="dialog-actions">
              <button type="button" onClick={onClose}>{t("Close")}</button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="current-password">{t("Current password")}</label>
              <input
                id="current-password"
                type="password"
                autoComplete="current-password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="new-password">{t("New password")}</label>
              <input
                id="new-password"
                type="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="repeat-password">{t("Repeat new password")}</label>
              <input
                id="repeat-password"
                type="password"
                autoComplete="new-password"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
                required
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            <div className="dialog-actions">
              <button type="button" className="dialog-cancel" onClick={onClose}>{t("Anuluj")}</button>
              <button type="submit" disabled={saving}>{t("Zapisz")}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ChangePasswordDialog;
